export default __webpack_public_path__ + "static/laveLingeZoomMobile-7d80ab94032c1c244c2ffe05d19dbc06.png";